import { IForecastWellRisk } from '../../interfaces/iforecast-well-risk';
import { ForecastHorizontal } from '../forecast-horizontal';

export class ForecastWellRiskBase {
  ForecastWellRiskId: number;
  WellId: number;
  Oil: number;
  Gas: number;
  Water: number;
  Created: Date | null;
  CreatedBy: string | null;
  Updated: Date | null;
  UpdatedBy: string | null;

  ForecastHorizontal?: ForecastHorizontal;

  constructor(item?: IForecastWellRisk) {
    if (item) {

      this.ForecastWellRiskId = item.ForecastWellRiskId;
      this.WellId = item.WellId;
      this.Oil = item.Oil;
      this.Gas = item.Gas;
      this.Water = item.Water;
      this.Created = item.Created ? new Date(item.Created) : null;
      this.CreatedBy = item.CreatedBy;
      this.Updated = item.Updated ? new Date(item.Updated) : null;
      this.UpdatedBy = item.UpdatedBy;

      this.ForecastHorizontal = new ForecastHorizontal(item.ForecastHorizontal);
    }
  }
}